import React from 'react';
import { Link } from 'react-router-dom';
import '../../../../../components/category-link/index.scss';
import './index.scss';
import { withQueries } from '../../../../../components/with-query';
import { useEntitiesRowQuery } from '../../../../../client/query/entities';

export class CategoriesRow extends React.Component {
  render() {
    const { data: categoryLinks } = this.props.categoryLinks;
    return (
      <section className="section categories-row">
        <div className="scroll-categories">
          <div className="contain-categories">
            {categoryLinks?.length &&
              categoryLinks.map((category, index) => {
                return (
                  <Link
                    key={index}
                    to={{
                      pathname: `/category/${encodeURIComponent(
                        category.title,
                      )}`,
                    }}
                    className="class-link"
                  >
                    {category.translatedTitle}
                  </Link>
                );
              })}
          </div>
        </div>
      </section>
    );
  }
}
export default withQueries({
  categoryLinks: function useEntitiesWithParams() {
    return useEntitiesRowQuery({
      groupBy: 'category',
      perPage: 0,
    });
  },
})(CategoriesRow);
